import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import IFilterModel from "../IFilterModel";



export default class ReminderFilterModel implements IFilterModel {
    search: string = '';
    resetToDefault() {
        this.search = '';
    }
    toFilterRequest(): SearchFilterRequest {
        return new SearchFilterRequest({
            Name: (this.search || '').trim()
        });
    }
}
